var Controller = require('controllers/base/controller');
var AccessibilityView = require('developer/views/accessibility/accessibility-view');

var LoadService = require('services/load-service');

var AccessibilityController = Controller.extend({
  report: function() {
    var self = this;
    LoadService.load({'report': 'raw/acc-output.json'})
      .done(function (accReport) {
        self.view = new AccessibilityView({
          region: 'main',
          model: new Chaplin.Model(accReport)
        });
      })
      .fail(function () {
        console.log("Couldn't load the accessibility report (Maybe you haven't generated it with `gulp acc-audit`?)");
      });
  }
});

module.exports = AccessibilityController;
